import type { ReactNode } from "react";

/** Секция с заголовком, который меняет цвет в edit-mode + показывает
 *  «Отмена» и счётчик изменённых полей. Унифицирует rf-section header
 *  для всех type-specific форм. */
export function EditableSection({
  title,
  editMode,
  draftCount,
  onCancelEdit,
  children,
}: {
  title: string;
  editMode: boolean;
  draftCount: number;
  onCancelEdit: () => void;
  children: ReactNode;
}) {
  return (
    <section
      className="rf-section"
      style={
        editMode
          ? { borderColor: "var(--blue-300, var(--blue-100))" }
          : undefined
      }
    >
      <div
        className="rf-section__head"
        style={
          editMode
            ? { background: "var(--blue-50)", color: "var(--blue-700)" }
            : undefined
        }
      >
        <span>{editMode ? "Режим правки" : title}</span>
        <span className="mt-toolbar__sep" style={{ flex: 1 }} />
        {editMode ? (
          <>
            <span
              className="mt-text-tight"
              style={{ textTransform: "none", letterSpacing: 0 }}
            >
              {draftCount} полей изменено
            </span>
            <button
              className="mt-btn mt-btn--sm mt-btn--ghost"
              onClick={onCancelEdit}
              type="button"
              style={{ marginLeft: 8 }}
            >
              Отмена
            </button>
          </>
        ) : (
          <span
            className="mt-text-tight mt-muted"
            style={{ textTransform: "none", letterSpacing: 0 }}
          >
            только просмотр · нажми «Изменить и принять» для правок
          </span>
        )}
      </div>
      <div className="rf-section__body">{children}</div>
    </section>
  );
}
